import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      visible: false,
      id: '',
      count: 0,
      buyParams: null
    };
  },
  computed: {
    curStarIndex: function curStarIndex() {
      var _this = this;

      return this.starList.findIndex(function (star) {
        return star.id === _this.id;
      });
    },
    curStar: function curStar() {
      return this.starList[this.curStarIndex];
    }
  },
  methods: {
    close: function close() {
      var _this2 = this;

      var share = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.visible = false; // 关闭后拉起对应的分享弹窗

      if (share) {
        var data = {
          starid: this.id
        };

        if (this.count) {
          data.propsCount = this.count;
        }

        if (this.buyParams) {
          // 通过买票流程过来的
          var item = this.starList.find(function (star) {
            return star.id === _this2.id;
          });

          var options = _objectSpread(_objectSpread({}, this.buyParams), {}, {
            starProps: this.count
          });

          if (item) {
            options.starName = item.明星剧名;
          }

          this.eventBus.$emit('launchShare', options);
        } else {
          this.launchPropsShare(data);
        }
      }

      this.clear();
    },
    clear: function clear() {
      this.id = '';
      this.count = 0;
    },
    bindEvent: function bindEvent() {
      var _this3 = this;

      this.eventBus.$on('showGetPowerPop', function (params) {
        console.log('event:showGetPowerPop:call', params);

        if (!params.id) {
          console.error('缺失明星id');
          return;
        }

        _this3.id = params.id;
        _this3.count = params.count;
        _this3.buyParams = params.buyParams;

        if (!_this3.curStar) {
          console.error('明星id有误');
          return;
        }

        _this3.visible = true;

        _this3.$nextTick(function () {
          _this3.initLottie();
        });
      });
    },
    launchBuy: function launchBuy() {
      this.close(false);
      this.eventBus.$emit('showPayPop', {
        id: this.id
      });
    },
    initLottie: function initLottie() {
      var _this4 = this;

      var paths = ['https://m.film.qq.com/vip-activity/lxky/static/lottie/particle/data.json', 'https://m.film.qq.com/vip-activity/lxky/static/lottie/wipes/data.json'];
      paths.forEach(function (path, i) {
        var key = "lottie".concat(i);
        var params = {
          container: _this4.$refs[key],
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: path
        };
        _this4[key] = window.bodymovin.loadAnimation(params);

        _this4[key].addEventListener('data_ready', function () {
          _this4[key].play();
        });
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};